import BottomModalDisplayState from "./BottomModalDisplayState";
import BottomModalIcon from "./BottomModalIcon";

export default class BottomModalState {
    constructor( props ) {
        if ( typeof props === "undefined" ) return;

        this.type    = props.type;
        this.obj     = props.obj;
        this.state   = ( props.initClosed ) ? BottomModalDisplayState.Closed : BottomModalDisplayState.Initial;
        this.title   = props.title;
        this.content = props.content;
    }

    get isOpen() {
        return this.state === BottomModalDisplayState.Open;
    }

    get isClosed() {
        return this.state === BottomModalDisplayState.Closed;
    }

    get isInitial() {
        return this.state === BottomModalDisplayState.Initial;
    }

    get infoSpotIcon() {
        if ( this.type === 'overview' ) {
            return new BottomModalIcon({
                type: 'overview'
            });
        }

        if ( this.obj.type === 'infospot' ) {
            return new BottomModalIcon({
                    type:    'spot',
                    content: this.obj.index
                }
            );
        }

        if ( this.obj.type === 'room' ) {

            if ( this.type === 'room' ) {
                return new BottomModalIcon({
                    type: 'room'
                });
            }

            if ( this.type === 'content' ) {
                return new BottomModalIcon({
                        type:       'info',
                        background: this.obj.thumbnail

                    }
                );
            }
        }

        return new BottomModalIcon({
            type: 'info'
        });
    }

    open() {
        this.state = BottomModalDisplayState.Open;
    }

    close() {
        this.state = BottomModalDisplayState.Closed;
    }
}
